import React, { useEffect, useState } from 'react';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { addDevice, generateCode, saveSubscriberLoginHistory } from '../../Api/api';
import { DISPLAYPLATFORM, LOCAL_STORAGE_KEY, PLATFORM } from '../../constant';
import { useDispatch } from 'react-redux';
import { utility } from '../../utility/utility';
import { setProfiles, setUser } from '../../redux/applicationSlice';
import { useNavigate } from 'react-router-dom';

const ActivateTvScreen = ({ ottSetting }) => {

    const [activationCode, setActivationCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { ref, focused, onEnterPress } = useFocusable({
        focusKey: 'ACTIVATE_TV_REFRESH_BUTTON',
        trackChildren: true,
        onEnterPress: () => generateActivationCode(),
        onArrowPress: (direction) => {
            if(direction === 'up'){
                return false;
            }
            return true;
        },
    });

    useEffect(() => {
        generateActivationCode();
    }, []);

    const generateActivationCode = async () => {
        setIsLoading(true);
        setError('');
        try {
            const response = await generateCode();
            if (response?.success) {
                const subscriber = response.data?.subscriber ?? {};
                if (subscriber && Object.keys(subscriber).length > 0) {
                    await addDevice(subscriber?._id, (subscriber?.Name + '`s Device'));
                    await saveSubscriberLoginHistory(subscriber?._id, PLATFORM[DISPLAYPLATFORM.TV].Description);
                    utility.setValue(LOCAL_STORAGE_KEY.user, subscriber);
                    dispatch(setUser(subscriber));
                    dispatch(setProfiles(subscriber?.Profiles ?? []));
                    navigate('/tv');
                    return;
                }
                setActivationCode(response.data.code);
            } else {
                setError(response?.message || 'Failed to generate code');
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{
            width: '50vw',
            height: '90%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            textAlign: 'center',
            padding: '40px',
            boxSizing: 'border-box',
        }}>
            <h2 style={{ fontSize: '2rem', marginBottom: '20px', fontWeight: '400' }}>
                Activate with your mobile app
            </h2>
            {isLoading ? (
                <div style={{ fontSize: '4rem', marginBottom: '40px' }}>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                </div>
            ) : (
                <div style={{
                    fontSize: '5rem',
                    fontWeight: 'bold',
                    letterSpacing: '20px',
                    marginBottom: '40px',
                    minHeight: '80px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    {activationCode || '----'}
                </div>
            )}
            <div style={{ marginBottom: '30px', maxWidth: '600px', textAlign: 'left' }}>
                <ol style={{
                    fontSize: '1.1rem',
                    lineHeight: '1.8',
                    margin: 0,
                    paddingLeft: '20px',
                }}>
                    <li>
                        Open the <strong>App</strong> on your phone or tablet.
                    </li>
                    <li>Go to <strong>"My Space"</strong> in the app's menu.</li>
                    <li>Tap <strong>Add Device</strong> and enter the code shown above.</li>
                </ol>
            </div>
            <button
                ref={ref}
                onClick={onEnterPress}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    padding: '10px 40px',
                    fontSize: '1.2rem',
                    backgroundColor: focused ? 'white' : 'transparent',
                    color: focused ? 'black' : 'white',
                    border: '2px solid white',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    marginTop: '20px',
                }}
            >
                <i className="fa fa-refresh" aria-hidden="true" />
                Refresh
            </button>
            {error && <div style={{ color: 'red', marginTop: '20px', fontSize: '1rem' }}>{error}</div>}
        </div>
    );
};

export default ActivateTvScreen;
